import { and, collectionGroup, getDocs, or, query, where } from "firebase/firestore";

export const normalizeTechnicianPaymentOrder = (order) =>
  String(order || "").replace(/\s+/g, "");

export const findTechnicianPaymentBooking = async (
  db,
  rawOrder,
  { paymentAccess, scopedTechName },
) => {
  const order = normalizeTechnicianPaymentOrder(rawOrder);
  if (!order || (!paymentAccess && !scopedTechName)) return null;

  const bookings = collectionGroup(db, "bookings");
  const scope = paymentAccess
    ? []
    : [
        or(
          where("extendedProps.technician", "==", scopedTechName),
          where("extendedProps.techrecord", "==", scopedTechName),
        ),
      ];
  const orderFilter = where("extendedProps.order", "==", order);
  const exact = await getDocs(
    query(bookings, paymentAccess ? orderFilter : and(orderFilter, ...scope)),
  );
  if (!exact.empty) return exact.docs[0];

  // Firestore cannot normalize stored strings. Only after an exact miss,
  // compare the accessible bookings locally, keeping the technician scope.
  const fallback = await getDocs(query(bookings, ...scope));
  return (
    fallback.docs.find((bookingDoc) => {
      const props = bookingDoc.data().extendedProps || {};
      return normalizeTechnicianPaymentOrder(props.order) === order;
    }) || null
  );
};
